import { Spin } from "antd";
import styled from "styled-components";

export const SpinStyled = styled(Spin)<{ $centered: boolean }>((props) => {
  if (props.$centered) {
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
    };
  }
});
